import { Checkbox, FormControlLabel, Stack } from "@vapor/react-material";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { useDocumentList } from "../../state/useDocumentList";

const AllNameSelector = () => {
  const {
    selectAllDocuments,
    toggleSelectAllDocuments,
    indeterminateCheck,
    setIndeterminateCheck,
  } = useDocumentList();

  const handleCheckboxChange = () => {
    //Toggle all document selected or no
    toggleSelectAllDocuments(!selectAllDocuments);
    setIndeterminateCheck(); // Set the checbox display if it is clicked for all documents or no (- or ✓)
  };
  return (
    <div>
      {
        <FormControlLabel
          sx={{
            margin: "0px",
            fontWeight: "400",
          }}
          control={
            <Checkbox
              checked={selectAllDocuments}
              indeterminate={indeterminateCheck}
              onChange={handleCheckboxChange}
            />
          }
          label={""}
        />
      }
      <Typography variant="body500" color="primary.textTitleColor">
        Nome
      </Typography>
    </div>
  );
};

export default AllNameSelector;
